import { State } from 'model/State';
import { selectXsrfToken } from './hamletClientConfig';

export default (state: State): boolean =>
  selectXsrfToken(state).ifSuccess((r) => r !== null) || false;
